import { actionTypes } from './constants';

export const flavorPagesActionTypes = {
  setSelectedRunIds: actionTypes.STACKCOMPONENT_PAGES_SET_SELECTED_RUN_IDS,
  setFetching: actionTypes.FLAVOR_PAGES_SET_FETCHING,
};
